exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".auth-view{height:100%;width:100%;background-repeat:no-repeat;background-position:50%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/js/views/AuthView/AuthView.less
 ** module id = 513
 ** module chunks = 1
 **/